import { render, staticRenderFns } from "./MerchantMessages.vue?vue&type=template&id=22628690"
import script from "./MerchantMessages.vue?vue&type=script&lang=js"
export * from "./MerchantMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports